export default {
    'configuration': 'Paramètres',
    'connexion': '',
    'cities': 'Communes',
    'cadastre': 'Cadastre',
    'limites_administratives_express': 'Limites administratives',
    'massif_forestier': 'Carte forestière v2',
    'massif_forestier_public': 'Forêts publiques',
    'zsm_gbarbu': 'ZSM Gypaète barbu',
    'zsm_vp': 'ZSM Vautour percnoptère',
    'natura2000': 'Natura 2000',

    // 09 LAYERS
    'n_enp_apb2_s_r76': 'Arrêté de Protection de Biotope',
    'r_do_s_r76': 'Natura 2000 ZPS',
    'Reserves_naturelles_regionales': 'Réserve Naturelle Régionale',
    'r_rncfs_s_r76': 'Réserve naturelle de chasse et de faune sauvage',
    'Reserves_biologiques': 'Réserve Biologique ONF',
    'N2000_ZSC': 'Sites Natura 2000 au titre de la Directive Habitats',
    // ------

    '31': 'Haute-Garonne',
    '09': 'Ariège',
    '64': 'Pyrénées-Atlantiques',
    '65': 'Hautes-Pyrénées',
    '12': 'Aveyron',
    'ressources': {
        index: 'Ressources',
    },
    'politiqueconfidentialite': 'Politique de confidentialité',
    'homepage_html': {
        toaster: {
            PUT: {
                success: {
                    title: 'Page d\'accueil',
                    text: 'La page d\'accueil a été mise à jour',
                },
            },
        },
    },
    'tableaudebord': {
        index: 'Tableau de bord',
    },
    'cartebrulages': 'Carte des brûlages',
    'circuitdevalidation': 'Circuit de validation des déclarations',
    'profil': 'Mon profil',
    'profilorganisme': 'Mon territoire de compétences',
    'utilisateurskformulaire': 'Utilisateurs',
    'utilisateursk': 'Utilisateurs',
    'utilisateurs': {
        toaster: {
            POST: {
                success: {
                    title: 'Compte utilisateur',
                    text: 'Les informations {name} ont été enregistrées',
                },
            },
            PUT: {
                success: {
                    title: 'Compte utilisateur',
                    text: 'Les informations {name} ont été enregistrées',
                },
            },
            DELETE: {
                success: {
                    title: 'Compte utilisateur',
                    text: 'Le compte utilisateur a été supprimé',
                },
            },
        },
        index: 'Utilisateurs',
        add: 'Ajouter un utilisateur',
        export: 'Exporter les utilisateurs',
        view: 'Fiche utilisateur',
        edit: 'Fiche utilisateur',
        reset_password: 'Réinitialiser mot de passe',
        credentials: {
            created_at: 'Compte crée le',
        },
        validated_at: 'Compte validé le',
        reason: 'Motif lors de l\'inscription',
        delete: {
            index: 'Supprimer',
            title: 'Supprimer l\'utilisateur',
            text: 'L\'utilisateur <b>{name}</b> va être définitivement supprimé. <br/> Souhaitez-vous continuer ?',
        },
        name: 'Nom',
        email: 'E-mail',
        last_login: 'Dernière connexion',
        contact: {
            name: 'Nom',
            email: 'E-mail',
            address: 'Adresse',
            postcode: 'Code postal',
            city: 'Commune',
            phone: 'Téléphone',
            mobile: 'Mobile',
        },
        active: {
            index: 'Utilisateur activé',
            true: 'Seulement les actifs',
            false: 'Seulement les désactivés',
            all: 'Tous',
        },
        organization: {
            index: 'Nom du territoire de compétences',
            v: 'Nom du territoire de compétences',
            name: 'Nom du territoire de compétences',
        },
        organization_id: 'Territoire de compétences',
        role: {
            index: 'Rôle',
            guest: 'Invité',
            declarant: 'Déclarant',
            admin: 'Administrateur',
            mairie: 'Maire',
            admin_cle: 'Administrateur CLE',
            animateur_cle: 'Animateur CLE',
            ddt: 'DDT',
            sdis: 'SDIS',
            onf: 'ONF',
            cdbd: 'CDBD',
            consultation: 'Consultation',
            consultation_manage_users: 'Consultation & Gestion des utilisateurs',
        },
        password: 'Mot de passe',
        passwordConfirm: 'Confirmation du mot de passe',
        group_notifications: 'Recevoir une seule notification e-mail journalièrement',
        receive_notifications: 'Recevoir des notifications par e-mail',
        where_is_new_user: {
            index: 'Nouvel utilisateur',
            new_user: 'Seulement les nouveaux utilisateurs',
            old_user: 'Seulement les anciens utilisateurs',
        },
    },
    'organismeskformulaire': '',
    'organismesk': '',
    'organismes': {
        toaster: {
            POST: {
                success: {
                    title: 'Territoire de compétences',
                    text: '{name} a été enregistré',
                },
            },
            PUT: {
                success: {
                    title: 'Territoire de compétences',
                    text: '{name} a été enregistré',
                },
            },
            DELETE: {
                success: {
                    title: 'Territoire de compétences',
                    text: 'Le territoire de compétences a été supprimé',
                },
            },
        },
        index: 'Territoire de compétences',
        add: 'Ajouter un territoire de compétences',
        export: 'Exporter les territoires de compétences',
        view: 'Voir le territoire de compétences : <small>{name}</small>',
        edit: 'Modifier le territoire de compétences : <small>{name}</small>',
        delete: {
            index: 'Supprimer le territoire de compétences',
            title: 'Supprimer le territoire de compétences',
            text: 'Vous allez supprimer définitivement le territoire de compétences {name}.<br><ul><li>Si des informations de ce type doivent apparaitrent sur le PDF des déclarations, elles n\'apparaitront plus.</li><li> Si le type est une CLE, les communes associées ne passeront plus en CLE. </li></ul><br/> Souhaitez-vous continuer ?',
        },
        name: 'Nom du territoire de compétences',
        type: {
            index: 'Type',
            dept: 'Département',
            mairie: 'Mairie',
            cle: 'CLE',
            onf: 'ONF',
            ddt: 'DDT',
            sdis: 'SDIS',
            cdbd: 'CDBD',
        },
        users_count: 'Utilisateurs',
        communes_count: 'Communes',
        commune_name: 'Communes',
        communes_complete: 'Communes',
        commune_id: 'Commune',
        communes: {
            id: 'Nom de la commune',
        },
        code: 'Code',
        phone: 'Téléphone',
        onf_phone: 'Téléphone ONF',
        ref_firstname: 'Prénom référent',
        ref_lastname: 'Nom référent',
        mayor: 'Nom du maire',
        approved: 'Organisme agréé',
        police_phone: 'Téléphone gendarmerie',
        cle: {
            date_cle: 'Date de la CLE',
        },
    },
    'declarationskformulaire': 'Déclarations',
    'declarationsk': 'Déclarations',
    'declarations': {
        calculating: 'Calcul des étapes',
        duplicated_from_id: 'Déclaration dupliquée depuis le numéro',
        duplicated_from: 'Dupliquée depuis la déclaration n°',
        toaster: {
            POST: {
                success: {
                    title: 'Déclarations',
                    text: 'Les informations {name} ont été enregistrées',
                },
            },
            PUT: {
                success: {
                    title: 'Déclarations',
                    text: 'Les informations {name} ont été enregistrées',
                },
            },
            DELETE: {
                success: {
                    title: 'Déclarations',
                    text: 'La déclaration a été supprimée',
                },
            },
        },
        created_by_me: {
            index: 'Mes déclarations',
            true: 'Déclarations que j’ai soumises',
            false: 'Toutes les déclarations de mon territoire de compétences',
        },
        selected: {
            delete: {
                index: 'Supprimer',
                title: 'Supprimer les déclarations sélectionnées',
                text: 'Souhaitez-vous supprimer <b>définitivement</b> {number} déclarations ?',
            },
        },
        index: 'Déclarations',
        add: 'Ajouter une déclaration',
        export: 'Exporter les déclarations',
        view: 'Voir la déclaration {k}',
        pdf: 'Télécharger le PDF',
        edit: 'Modifier la déclaration {k}',
        delete: {
            index: 'Supprimer la déclaration',
            title: 'Supprimer la déclaration',
            text: 'Vous allez supprimer définitivement la déclaration {k}. Souhaitez-vous continuer ?',
        },
        archive_signature: {
            index: 'Supprimer la signature',
            title: 'Supprimer la signature',
            text: 'Souhaitez-vous supprimer la signature de la déclaration n°{k} ? La déclaration redeviendra modifiable et pourra être re-signée.',
        },
        copy: {
            index: 'Copier les déclarations',
            withNotices: 'Avec les avis',
            withoutNotices: 'Sans les avis',
        },
        map: {
            legend: {
                propertyToShow: 'id',
            },
        },
        crossing: {
            index: 'Croisements',
            forest: 'Forêt',
            forest_rf: 'Forêt RF',
            zsm: 'ZSM',
            clean: 'Aucun',
        },
        crossing_forest: {
            index: 'Croisement Forêt',
            true: 'Oui',
            false: 'Non',
        },
        crossing_zsm: {
            index: 'Croisement ZSM',
            true: 'Oui',
            false: 'Non',
        },
        crossing_natura2000: {
            index: 'Croisement Natura 2000',
            true: 'Oui',
            false: 'Non',
        },
        name: 'Nom de la déclaration',
        id: 'Numéro',
        called_place: 'Lieu-dit',
        start_date: 'Date de début de réalisation',
        end_date: 'Date de fin de réalisation',
        status: {
            index: 'Statut',
            none: 'En cours de calcul',
            created: 'Déposée',
            in_progress: 'En cours d\'instruction',
            valid: 'Validée',
            tacit_valid: 'Validation tacite',
            invalid: 'Refusée',
        },
        season_id: 'Saison',
        seasons: {
            id: 'Saison',
        },
        season: {
            index: 'Saison',
            name: 'Saison',
        },
        declarants: {
            name: 'Prénom et nom du déclarant',
        },
        declarant_id: 'Déclarant',
        declarant: {
            index: 'Prénom et nom du déclarant',
            name: 'Prénom et nom du déclarant',
            address: 'Adresse du déclarant',
            postcode: 'Code postal du déclarant',
            city: 'Commune du déclarant',
            phone: 'Téléphone du déclarant',
            mobile: 'Mobile du déclarant',
            email: 'E-mail du déclarant',
        },
        commune_id: 'Commune',
        communes: {
            id: 'Commune',
        },
        commune: {
            index: 'Commune',
            name: 'Commune',
        },
        geometry: 'Géométrie',
        declaration_type_id: 'Type de déclaration',
        declaration_types: {
            index: '',
            id: 'Type de déclaration',
            name: 'Nom',
            geometry_type: 'Type de géométrie',
            cle: 'CLE',
            start: 'Date de début',
            end: 'Date de fin',
            crossing_forest_calc: 'Intersect forêt',
            crossing_forest_rf_calc: 'Intersect RF',
            crossing_zsm_calc: 'Intersect ZSM',
            crossing_natura2000_calc: 'Intersect Natura2000',
            warning: 'Message d\'alerte',
            engagement: 'Message de validation du formulaire',
        },
        cles: {
            id: 'Clé',
        },
        passing_cle: {
            index: 'Passage en CLE',
            true: 'Oui',
            false: 'Non',
        },
        revision: 'Révision',
        current_step: 'Étape en cours',
        commitment: 'Engagement accepté',
        project_manager_id: 'Maître d\'oeuvre',
        project_manager: {
            index: 'Maître d\'oeuvre',
            name: 'Nom prénom du maître d\'oeuvre',
            phone: 'Téléphone du maître d\'oeuvre',
            mobile: 'Mobile du maître d\'oeuvre',
        },
        bd: {
            index: 'Brûlage dirigé',
            true: 'Oui',
            false: 'Non',
        },
        sdis_inspection: {
            index: 'Reco. SDIS',
            true: 'Oui',
            false: 'Non',
            update: {
                index: 'Mettre à jour',
                title: 'Mise à jour Reconnaissance SDIS',
                text: 'Souhaitez-vous mettre à jour la valeur de "reconnaissance sdis" de la déclaration {id} ?',
            },
        },
        last_burn_year: 'Année du dernier brûlage effectif connu de cette zone',
        cbp_stakes: {
            index: 'Type d\'enjeux CLE',
            risques: 'Risques',
            none: 'Aucun',
            securite: 'Sécurité',
            agricoles: 'Agricoles',
            forestiers: 'Forestiers',
            environnementaux: 'Environnementaux',
            surface: 'Surface',
        },
        cdbd_decision: {
            index: 'Avis CDBD',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        cdbd_opinion: 'Avis détaillé CDBD',
        cdbd_stakes: {
            index: 'Type d\'enjeux CDBD',
            risques: 'Risques',
            none: 'Aucun',
            securite: 'Sécurité',
            agricoles: 'Agricoles',
            forestiers: 'Forestiers',
            environnementaux: 'Environnementaux',
            surface: 'Surface',
        },
        mayor_decision: {
            index: 'Décision du maire',
            null: 'Pas de décision',
            true: 'Validé',
            false: 'Refusé',
        },
        mayor_acknowledgement: {
            index: 'Accusé de réception',
            null: 'Déposée',
            true: 'Accusé de réception envoyé',
        },
        mayor_opinion: 'Avis détaillé du maire',
        mayor_validation_date: 'Date de décision du maire',
        mayor_conform: 'Prise en compte des autres avis (CLE, ONF ...)',
        mayor_call: 'Si le déclarant doit appeler la mairie avant le brûlage',
        ddt_decision: {
            index: 'Avis DDT',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        ddt_interdiction: 'Interdiction',
        ddt_opinion: 'Avis détaillé DDT',
        cle_preconisation: 'Préconisation CLE',
        cle_last_year_preconisation: 'Préconisation CLE de l\'année précédente',
        cle_decision: {
            index: 'Avis CLE',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        onf_preconisation: 'Préconisation ONF',
        onf_call: 'Si le déclarant doit téléphoner à l\'ONF le jour du brûlage',
        onf_decision: {
            index: 'Avis ONF',
            null: 'Pas d\'avis',
            true: 'Favorable',
            false: 'Défavorable',
        },
        onf_required: {
            index: 'Croisement forêt RF',
            true: 'Oui',
            false: 'Non',
        },
        crossing_forest_public_type: {
            index: 'Type de croisement forêt RF',
            domanial: 'Forêt domaniale',
            private: 'Forêt non domaniale',
        },
        crossing_forest_public_domanial: 'Croisement forêt RF domanial',
        owner_id: 'Propriétaire',
        owner: {
            index: 'Propriétaire',
            name: 'Nom prénom du propriétaire',
        },
        owner_type: {
            index: 'Type de propriétaire',
            physique: 'Physique',
            morale: 'Moral',
        },
        declaration_type: {
            index: 'Type de déclaration',
            name: 'Type de déclaration',
        },
        declarant_type: {
            index: 'Type de déclarant',
            owner: 'Propriétaire',
            ind: 'Individuel',
            other: 'Autre',
            paf: 'Président d\'association foncière',
            pgp: 'Président de groupement pastoral',
            water_union: 'Syndicat des rivieres',
            have_right: 'Ayant droit',
            elu: 'Elu',
            etaf: 'Entreprise de travaux agricoles ou forestiers',
        },
        beneficiary_type: {
            index: 'Type d\'ayant droit',
            farmer: 'Fermier',
            tenant: 'Locataire',
            agent: 'Mandataire',
            heir: 'Héritier',
            forced_heir: 'Réservaire',
            purchaser: 'Adjudicataire de coupe',
            other: 'Autre',
        },
        cadastre_section: 'Section cadastrale',
        cadastre_parcel: 'Parcelle cadastrale',
        linear: 'Linéaire',
        heap_count: 'Nombre de tas',
        surface: 'Surface',
        demande_appui: {
            index: 'Demande d\'appui',
            none: 'Brûlage en autonomie',
            cle: 'Commission locale d\'écobuage ',
            cdbd: `Demande de conseil de la cellule départementale de brûlage dirigé`,
            cdbd_implementation: 'Demande d\'appui dans la mise en œuvre du chantier par la cellule départementale de brûlage dirigé',
        },
        more_burns_planned: 'D\'autres brûlages sont prévus pour cette déclaration',
        burn_status: {
            index: 'Statut de brûlage',
            update: {
                index: 'Mettre à jour',
                title: 'Mise à jour statut de brûlage',
                text: 'Souhaitez-vous mettre à jour le statut de brûlage de la déclaration {id} ?',
            },
            none: 'Aucun brûlage',
            null: 'Aucun brûlage',
            planned: 'Brûlage prévu',
            programmed: 'Brûlage programmé',
            ongoing: 'Brûlage en cours',
            partial: 'Brûlage part. réalisé',
            complete: 'Brûlage réalisé',
            archived: 'Brûlage archivé',
        },
        burn_type: {
            index: 'Type d\'écobuage',
            full: 'En plein',
            task: 'Par tâche',
            foot: 'Pied à pied',
        },
        participants: 'Nombre de participants',
        description: 'Description',
        vegetation_nature: 'Nature de la végétation à incinérer',
        vegetation_type: {
            index: 'Type de végétation',
            broussaille: 'Broussaille (ronce, fougère...)',
            old: 'Obligation légale de débrouisaillement',
            jeune_boisement: 'Jeune boisement',
            boisement_adulte: 'Boisement adulte',
            vegetation_arbustive: 'Végétation arbustive',
            arbre_isole: 'Arbre isolé',
            forest: 'Gestion forestière',
            other: 'Autres résidus végétaux issus de parcelles agricoles',
            culture: 'Culture',
        },
        number: 'Numéro chantier',
        organization_id: 'Territoires',
        where_checked_by_org_type: {
            index: 'Traitées par',
            dept: 'Département',
            mairie: 'Mairie',
            cle: 'CLE',
            onf: 'ONF',
            ddt: 'DDT',
            sdis: 'SDIS',
            cdbd: 'CDBD',
        },
        where_checked_value: {
            index: 'Avis',
            null: 'Non traitée',
            true: 'Favorable',
            false: 'Défavorable',
        },
        where_treatment_by: {
            index: 'À traiter par',
            dept: 'Département',
            mairie: 'Mairie',
            cle: 'CLE',
            onf: 'ONF',
            ddt: 'DDT',
            sdis: 'SDIS',
            cdbd: 'CDBD',
        },
        where_treatment_required: {
            index: 'Type d\'intervention',
            null: 'Tous',
            true: 'Obligatoire',
            false: 'Facultatif',
        },
        where_cle: {
            index: 'Clé',
        },
        brulages: {
            index: 'Brûlage',
            date: 'Date de brûlage',
            surface: 'Surface brûlée',
            description: 'Commentaire sur le brûlage',
        },
        date: 'Date',
        declaration_id: 'N° Déclaration',

    },
    'export': {
        declaration_64: 'Fiches PDF des déclarations',
        declaration_65: 'Fiches PDF des déclarations',
        declaration_31: 'Fiches PDF des déclarations',
        declaration_09: 'Fiches PDF des déclarations',
        declaration_mayor_list: 'Tableau des demandes d\'écobuage mairie',
    },
    'journaldesmodifications': {
        index: 'Historique des déclarations',
        declaration_id: 'N° Déclaration',
        revision: 'Révision',
        declaration_revision: 'Révision',
        event_type: {
            index: 'Action',
            created: 'Création',
            updated: 'Modification',
            deleted: 'Suppression',
            restored: 'Restauration',
        },
        model: {
            Burn: 'Brûlage',
            Contact: 'Contact',
            Declaration: 'Déclaration',
        },
        after_values: 'Détail',
        commune: {
            name: 'Commune',
        },
        communes: {
            id: 'Communes',
        },
    },
    'geometry_type_text': {
        Polygon: 'une zone de chantier',
        MultiPolygon: 'une ou plusieurs zones de chantier',
        Point: 'un point',
        MultiPoint: 'un ou plusieurs points',
    },
    'declarationsspecialessdisk': 'Liste des déclarations spéciales SDIS',
    'declarationsspecialessdiskformulaire': 'Liste des déclarations spéciales SDIS',
    'declarationsspecialessdis': {
        index: 'Liste des déclarations spéciales SDIS',
        add: 'Ajouter une déclaration spéciale SDIS',
        view: 'Voir la déclaration spéciale SDIS {id}',
        edit: 'Modifier la déclaration spéciale SDIS {id}',
        delete: {
            index: 'Supprimer',
            text: 'Souhaitez-vous vraiment supprimer la déclaration SDIS "Numéro {id}" ?',
            title: 'Supprimer la déclaration SDIS <span class="text-caption text-medium-emphasis">{id}</span>',
        },
        id: 'Numéro',
        start_date: 'Date de brûlage',
        name: 'Nom du déclarant',
        phone: 'Téléphone du déclarant',
        email: 'E-mail du déclarant',
        description: 'Description',
        commune: {
            index: 'Commune',
            name: 'Commune',
        },
        communes: {
            id: 'Communes',
        },
        address: 'Lieu du brûlage',
        surface: 'Surface estimée',
        has_geometry: 'Géométrie dessinée',
        toaster: {
            DELETE: {
                success: {
                    text: 'La déclaration SDIS numéro {id} a bien été supprimée',
                    title: 'Déclaration spéciale SDIS supprimée',
                },
            },
            POST: {
                success: {
                    text: 'La déclaration spéciale SDIS numéro {id} a bien été créée',
                    title: 'Déclaration spéciale SDIS créée',
                },
            },
            PUT: {
                success: {
                    text: 'La déclaration spéciale SDIS numéro {id} a bien été mise à jour',
                    title: 'Déclaration spéciale SDIS sauvegardée',
                },
            },
        },
    },
    'couchescartographiques': {
        index: 'Liste des couches cartographiques',
        add: 'Ajouter une couche cartographique',
        view: 'Voir une couche cartographique {layer_type}',
        edit: 'Modifier une couche cartographique {layer_type}',
        delete: {
            index: 'Supprimer',
            text: 'Souhaitez-vous vraiment supprimer la couche "{name}" ?',
            title: 'Supprimer la couche <span class="text-caption text-medium-emphasis">{name}</span>',
        },
        new: 'Ajouter une couche cartographique',
        formulaire: {
            nouveau: 'Ajouter une couche cartographique',
        },
        layer_type: {
            index: 'Type de couche',
            xyz: 'xyz',
            MapServiceLayer: 'Service cartographique',
        },
        name: 'Nom',
        title: 'Titre',
        abstract: 'Description',
        url: 'Url',
        legend_url: 'Légende URL',
        legend_html: 'Légende HTML',
        attribution: 'Attribution',
        show: 'Affichée par défaut',
        order: 'Ordre d\'affichage',
        map_service_id: 'Service cartographique',
        service: {
            index: 'Service cartographique',
            title: 'Titre du service cartographique',
        },
        toaster: {
            DELETE: {
                success: {
                    text: 'La couche {name} a bien été supprimée',
                    title: 'Couche cartographique supprimée',
                },
            },
            POST: {
                success: {
                    text: 'La couche {name} a bien été créée',
                    title: 'Couche cartographique sauvegardée',
                },
            },
            PUT: {
                success: {
                    text: 'La couche {name} a bien été mise à jour',
                    title: 'Couche cartographique sauvegardée',
                },
            },
        },
    },
    'servicescartographiques': {
        index: 'Liste des services cartographiques',
        add: 'Ajouter un service cartographique',
        view: 'Voir un service cartographique {service_type}',
        edit: 'Modifier un service cartographique {service_type}',
        delete: {
            index: 'Supprimer',
            text: 'Souhaitez-vous vraiment supprimer le service "{name}" ?',
            title: 'Supprimer le service <span class="text-caption text-medium-emphasis">{name}</span>',
        },
        new: 'Ajouter un service cartographique',
        formulaire: {
            nouveau: 'Ajouter un service cartographique',
        },
        service_type: {
            index: 'Type de service',
            WMS: 'WMS',
            WMTS: 'WMTS',
        },
        name: 'Nom',
        title: 'Titre',
        abstract: 'Description',
        url: 'Url',
        activesLayersCount: 'Nombre de couches',
        layers: {
            index: 'Couches cartographiques',
            title: 'Titre',
            name: 'Nom',
            abstract: 'Description',
        },
        toaster: {
            DELETE: {
                success: {
                    text: 'Le service {name} a bien été supprimé',
                    title: 'Service supprimé',
                },
            },
            POST: {
                success: {
                    text: 'Le service {name} a bien été créé',
                    title: 'Service sauvegardé',
                },
            },
            PUT: {
                success: {
                    text: 'Le service {name} a bien été mise à jour',
                    title: 'Service sauvegardé',
                },
            },
        },
    },
    'tableaudebordbrulages': 'Tableau de bord',
    'notificationsalertes': 'Alertes et infos',
    'notificationsalertesk': 'Alertes et infos',
    'notificationsalerteskformulaire': 'Alertes et infos',
    'notificationAlert': {
        index: 'Alertes et infos',
        view: 'Voir l\'alerte {level}',
        add: 'Programmer une alerte',
        edit: 'Modifier une alerte',
        id: 'Numéro',
        level: {
            index: 'Niveau de vigilance',
            info: 'Faible',
            warning: 'Modérée',
            danger: 'Maximale',
        },
        organizations: {
            index: 'Territoires',
        },
        start_date: 'Date de début',
        end_date: 'Date de fin',
        description: 'Contenu',
        show_website: 'Afficher sur les pages SERPIC',
        send_mail: 'Envoyer par mail',
        send_phone: 'Envoyer par SMS',
        burning_forbidden: 'Interdire les brûlages',
        delete: {
            index: 'Supprimer',
            title: 'Supprimer l\'alerte',
            text: 'L\'alerte du <b>{start_date}</b> va être définitivement supprimée. <br/> Souhaitez-vous continuer ?',
        },
        toaster: {
            DELETE: {
                success: {
                    text: 'L\'alerte numéro {id} a bien été supprimée',
                    title: 'Alerte supprimée',
                },
            },
            POST: {
                success: {
                    text: 'L\'alerte  numéro {id} a bien été créée',
                    title: 'Alerte créée',
                },
            },
            PUT: {
                success: {
                    text: 'L\'alerte  numéro {id} a bien été mise à jour',
                    title: 'Alerte sauvegardée',
                },
            },
        },
        where_active: {
            index: 'État des alertes',
            true: 'Actives',
            false: 'Inactives',
        },
    },
    'burns': {
        toaster: {
            POST: {
                success: {
                    title: 'Brûlage enregistré',
                    text: 'Votre déclaration de brûlage a été enregistré',
                },
            },
        },
        id: 'Numéro',
        declarantName: 'Nom du déclarant',
        declarationId: 'Numéro de la déclaration',
        surfacePlanned: 'Surface prévisionnelle',
        date: 'Date du brûlage',
        surface: 'Surface',
        description: 'Informations complémentaires',
        datePlanned: 'Dates prévisionnelles',
        openBurns: 'Brûlage à terminer',
        endDescription: 'Informations complémentaires',
        endSubmitSuccess: 'La fin de votre brûlage a bien été enregistrée.<br> <strong>Un e-mail de confirmation vient de vous être envoyé.</strong>',
        submitSuccess: 'Nous vous remercions pour cette précision qui aide nos services techniques à anticiper les opérations.<br> <strong>Un e-mail de confirmation vient de vous être envoyé </strong> avec le récapitulatif de votre déclaration.',
    },
    'ajouterdatebrulage': 'Déclarer une date de brûlage',
    'declarerfinbrulage': 'Déclarer la fin d\'un brûlage',
    'date': 'Date',
    'burn_date_only_declaration_valid_for_declarant': 'Activer la saisie des brûlages pour les déclarants uniquement pour les dossiers ayant le statut \'Validé\' ou \'Validé tacitement\'.',
}
